import { NgModule } from '@angular/core';

import { DroppableDirective } from './directives/droppable.directive';
import { FreeDraggableDirective } from './directives/free-draggable.directive';
import { FreeDroppableDirective } from './directives/free-droppable.directive';
import { SortableContainerDirective } from './directives/sortable-container.directive';
import { SortableDirective } from './directives/sortable.directive';

@NgModule({
  declarations: [
    FreeDraggableDirective,
    FreeDroppableDirective,
    DroppableDirective,
    SortableContainerDirective,
    SortableDirective,
  ],
  exports: [
    FreeDraggableDirective,
    FreeDroppableDirective,
    DroppableDirective,
    SortableContainerDirective,
    SortableDirective,
  ],
})
export class SFDragDropModule {}
